import script from "./software.vue?vue&type=script&setup=true&lang=js"
export * from "./software.vue?vue&type=script&setup=true&lang=js"

import "./software.vue?vue&type=style&index=0&id=acfbae30&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-acfbae30"]])

export default __exports__